<template lang="html">

  <el-select class="inpText" size="medium" @change="selectChange" v-model="id" placeholder="请选择">
      <el-option
        v-for="item in selectArr"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
  </el-select>

</template>

<script>
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    props:['code','selectId','paramsKey'],
    watch:{
         selectId:function(e){
             this.id = e;
         },
         id:function(e){
             this.$emit('selectChange',{
                 id:e,
                 name:this.dectMap[this.id],
                 paramsKey:this.paramsKey
             })
         }
    },
    data(){
        return{
            id:'',
            selectArr:[],
            dectMap:{}
        }
    },
    methods:{

    },
    created:function(){
        var vues = this;
        dicSeek({code:this.code}).then(res => {
            var unFormate = res.dataDictionarys;
            vues.selectArr = unFormate;
            for(var i = 0;i < unFormate.length;i++){
                vues.dectMap[unFormate[i].id] = unFormate[i].name;
            }

        })

        console.log(this.paramsKey)
    }

}
</script>

<style lang="css" scoped>



</style>



// WEBPACK FOOTER //
// dcSelect.vue?63540b62